import { render, staticRenderFns } from "./permisos.vue?vue&type=template&id=41a7705c&scoped=true"
import script from "./permisos.vue?vue&type=script&lang=js"
export * from "./permisos.vue?vue&type=script&lang=js"
import style0 from "./permisos.vue?vue&type=style&index=0&id=41a7705c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a7705c",
  null
  
)

export default component.exports